__turbopack_context__.v({
  "acheivername": "psy-optional-module__hkwO1W__acheivername",
  "acheivername1": "psy-optional-module__hkwO1W__acheivername1",
  "acheiverrank": "psy-optional-module__hkwO1W__acheiverrank",
  "acheiverrank1": "psy-optional-module__hkwO1W__acheiverrank1",
  "acheiverrank2": "psy-optional-module__hkwO1W__acheiverrank2",
  "acheiverrank3": "psy-optional-module__hkwO1W__acheiverrank3",
  "acheiverrank4": "psy-optional-module__hkwO1W__acheiverrank4",
  "acheivertitle": "psy-optional-module__hkwO1W__acheivertitle",
  "ansheet": "psy-optional-module__hkwO1W__ansheet",
  "bgboxbg": "psy-optional-module__hkwO1W__bgboxbg",
  "captcha": "psy-optional-module__hkwO1W__captcha",
  "checkboxcontent": "psy-optional-module__hkwO1W__checkboxcontent",
  "classesborder": "psy-optional-module__hkwO1W__classesborder",
  "contactbox": "psy-optional-module__hkwO1W__contactbox",
  "contactboxheight": "psy-optional-module__hkwO1W__contactboxheight",
  "contactsubcontent": "psy-optional-module__hkwO1W__contactsubcontent",
  "gshad": "psy-optional-module__hkwO1W__gshad",
  "img": "psy-optional-module__hkwO1W__img",
  "imgboxbelow": "psy-optional-module__hkwO1W__imgboxbelow",
  "invalidCheck2": "psy-optional-module__hkwO1W__invalidCheck2",
  "mainshead": "psy-optional-module__hkwO1W__mainshead",
  "mbtableheading": "psy-optional-module__hkwO1W__mbtableheading",
  "medalicon": "psy-optional-module__hkwO1W__medalicon",
  "mobhead": "psy-optional-module__hkwO1W__mobhead",
  "mobilemaillinks": "psy-optional-module__hkwO1W__mobilemaillinks",
  "more": "psy-optional-module__hkwO1W__more",
  "normalbutton": "psy-optional-module__hkwO1W__normalbutton",
  "normalbutton2": "psy-optional-module__hkwO1W__normalbutton2",
  "pagemaintitle": "psy-optional-module__hkwO1W__pagemaintitle",
  "paybill": "psy-optional-module__hkwO1W__paybill",
  "paybills": "psy-optional-module__hkwO1W__paybills",
  "redunderline": "psy-optional-module__hkwO1W__redunderline",
  "sectiontitle": "psy-optional-module__hkwO1W__sectiontitle",
  "sectiontitle1": "psy-optional-module__hkwO1W__sectiontitle1",
  "sectiontitle2": "psy-optional-module__hkwO1W__sectiontitle2",
  "subhead": "psy-optional-module__hkwO1W__subhead",
  "tableheading": "psy-optional-module__hkwO1W__tableheading",
  "tablepara": "psy-optional-module__hkwO1W__tablepara",
  "tablepara1": "psy-optional-module__hkwO1W__tablepara1",
  "tablescroll": "psy-optional-module__hkwO1W__tablescroll",
  "toppersupsc": "psy-optional-module__hkwO1W__toppersupsc",
  "viewbutton": "psy-optional-module__hkwO1W__viewbutton",
});
